// extracted by mini-css-extract-plugin
module.exports = {"prevBtn":"index-prevBtn-ZZZo7","nextBtn":"index-nextBtn-ENEX-","tabSwiper":"index-tabSwiper-JVWCR"};